const Footer = () => {
    return (
        <div className="footer">
            Tried making with care (❁´◡`❁), by : {` `}
            <a className="nav-link" href="https://github.com/jatinsajwan3841">
                jatin
            </a>
        </div>
    )
}

export default Footer
